import { Action } from '@ngrx/store';
import { ActionOptionsArgs, SynchronisableAction } from '../../../core/store/actions/base-actions';
import { Membership } from './membership.model';

export const ENTITY = 'membership';
export const REHYDRATE = '[Membership] Rehydrate';
export const REMOVE = '[Membership] Remove';
export const REFRESH = '[Membership] Refresh';
export const SUBMIT = '[Membership] Submit';

export class RefreshAction implements Action {
    readonly entity = ENTITY;
    readonly type = REFRESH;

    constructor(public payload: Membership) {

    }
}

export class RehydrateAction implements Action {
    readonly type = REHYDRATE;

    constructor(public payload: Array<Membership>) {

    }
}

export class RemoveAction extends SynchronisableAction {
    readonly entity = ENTITY;
    readonly type = REMOVE;

    constructor(public payload: Membership, options?: ActionOptionsArgs) {
        super(payload, options);
    }

    getKey(): string {
        return `${this.entity}:entity:${this.payload.id}`;
    }
}

export class SubmitAction extends SynchronisableAction {
    readonly entity = ENTITY;
    readonly type = SUBMIT;

    constructor(public payload: Membership, options?: ActionOptionsArgs) {
        super(payload, options);
    }

    getKey(): string {
        return `${this.entity}:entity:${this.payload.id}`;
    }
}

export type Actions
    = RefreshAction
    | RehydrateAction
    | RemoveAction
    | SubmitAction;



// WEBPACK FOOTER //
// ./src/vas/business-objects/membership/membership.actions.ts